import React, { Component } from 'react';

class Section extends Component {
  render() {
    return (
      <div className="home-section">
        <h3>{this.props.header}</h3>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export default Section;
